/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Reload } from '../../assets/themes/OPL/img/icons/Reload.svg';

function RefreshButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Reload}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

RefreshButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default RefreshButton;
